import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, description, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : "text-left"}>
    <p className="text-xs font-semibold tracking-[0.25em] uppercase text-brand-bronze-dark" data-testid={`${overline?.toLowerCase().replace(/\s+/g, "-")}-overline`}>
      {overline}
    </p>
    <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-stone-900">
      {title}
    </h2>
    {description && (
      <p className={`mt-6 max-w-2xl text-base md:text-lg font-light leading-relaxed text-stone-600 ${align === "center" ? "mx-auto" : ""}`}>
        {description}
      </p>
    )}
  </Reveal>
);
